import { KAKAO_AD_TRACK_ID } from "constant";

/* global kakaoPixel */

export const kakaoPixelContext = (window as any).kakaoPixel ? kakaoPixel(KAKAO_AD_TRACK_ID) : null;
